import { render, staticRenderFns } from "./commodityTypes.vue?vue&type=template&id=4309dcfd&scoped=true"
import script from "./commodityTypes.vue?vue&type=script&lang=js"
export * from "./commodityTypes.vue?vue&type=script&lang=js"
import style0 from "./commodityTypes.vue?vue&type=style&index=0&id=4309dcfd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4309dcfd",
  null
  
)

export default component.exports